/*
 * Copyright 2022 StarTree Inc.
 *
 * All rights reserved. Confidential and proprietary information of StarTree Inc.
 */
import numbro from "numbro";
import { enUS } from "../../locale/numbers/en-us";

export const registerLanguages = (): void => {
    numbro.registerLanguage(enUS);
};
